// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/crmDashboardService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { CrmDashboard, AlertaCrm } from '../types';

const BASE = '/api/crm/dashboard';

export const crmDashboardService = {
  async obter(mesesEvolucao = 12, diasAtraso = 1): Promise<CrmDashboard> {
    const { data } = await apiClient.get<CrmDashboard>(BASE, {
      params: { mesesEvolucao, diasAtraso },
    });
    return data;
  },

  async listarAlertas(diasAtraso = 1): Promise<AlertaCrm[]> {
    const { data } = await apiClient.get<AlertaCrm[]>(`${BASE}/alertas`, {
      params: { diasAtraso },
    });
    return data;
  },
};
